import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CardInstruction from '../../../../components/CardInstruction';

import { getStatementServiceId } from '../../../form/StatementLetterForm/functions';

const Married = ({ i18n, statementServiceList }) => {
  const lang = (type, params) => i18n(`statement_letter.tab2.${type}`, { ...params });
  const serviceId = getStatementServiceId(statementServiceList, 'married');

  const stepOuterList = [
    {
      label: i18n('statement_letter.step.report_self.title')
    },
    // {
    //   label: i18n('statement_letter.step.take_number.title'),
    //   cta: i18n('statement_letter.step.take_number.cta'),
    //   link: `/statement-letter/registration/create?type=statement&serviceId=${serviceId}`
    // },
    {
      label: i18n('statement_letter.step.field_form.title', {
        type: i18n('statement_letter.tab2.title')
      }),
      linkType: true,
      iconCta: 'download',
      ctaColor: 'outline',
      cta: i18n('statement_letter.step.field_form.cta'),
      link: 'https://drive.google.com/file/d/1rNTTjqCMSg_NInRLs0tlaHQNdo3i97tv/view'
    }
  ];

  const instructionList = [
    i18n('statement_letter.instruction_step.copy_marriage_certificate'),
    i18n('statement_letter.instruction_step.copy_passport_spouse'),
    i18n('statement_letter.instruction_step.copy_id_spouse'),
    i18n('statement_letter.instruction_step.stay_permit_spouse'),
    i18n('statement_letter.instruction_step.proof_address_spouse'),
    i18n('statement_letter.instruction_step.no_fee')
  ];

  return (
    <CardInstruction
      stepOuterList={stepOuterList}
      instructionList={instructionList}
      lang={lang}
    />
  );
};

Married.propTypes = {
  i18n: PropTypes.func,
  statementServiceList: PropTypes.array
};

const mapStateToProps = (state) => ({
  i18n: state.langReducer.i18n
});

export default connect(mapStateToProps)(Married);
